import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useReOrderSubTopics({ classID, courseID, chapterID, topicID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function reOrderSubTopics(data = {}) {
    return privateFetch
      .post(
        `/v1/admin/class/${classID}/course/${courseID}/chapter/${chapterID}/topic/${topicID}/subtopic/re-order`,
        data
      )
      .then((res) => res.data);
  }

  return useMutation(reOrderSubTopics, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('chapters');
    },
  });
}

export default useReOrderSubTopics;
